import { API_BASE, getAuthHeaders, apiFetch } from './api-fetch';
import { API, buildPath } from './api-endpoints';

export const imageUploadAPI = {
  // Upload an image (accepts File or base64 data URL)
  async uploadImage(file: File, propertyId?: string): Promise<{ url: string; path: string }> {
    try {
      // Convert file to base64
      const reader = new FileReader();
      const base64Data = await new Promise<string>((resolve, reject) => {
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

      // Strip the data URL prefix to get raw base64 string
      const imageBase64 = base64Data.includes(',') ? base64Data.split(',')[1] : base64Data;

      const response = await apiFetch(`${API_BASE}${API.images.upload.path}`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          imageBase64,
          fileName: file.name,
          contentType: file.type,
          folder: propertyId ? `properties/${propertyId}` : undefined,
        }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to upload image');
      }

      const data = await response.json();
      return { url: data.data?.url ?? data.url, path: data.data?.path ?? data.path };
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error;
    }
  },

  // Delete an image by ID — DELETE /images/{id}
  async deleteImage(id: string): Promise<void> {
    try {
      const response = await apiFetch(`${API_BASE}${buildPath(API.images.delete.path, { id: encodeURIComponent(id) })}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to delete image');
      }
    } catch (error) {
      console.error('Error deleting image:', error);
      throw error;
    }
  },
};